import { TPlainObject } from '@flatbiz/utils';
import { CSSProperties, FC } from 'react';
import { NativeProps, withNativeProps } from '../utils/native-props';

export type GridItemProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  xSpan?: number;
  ySpan?: number;
} & NativeProps;

/**
 * Grid单元格
 * ```
 * 1. xSpan: 单元格水平方向格数
 * 1. ySpan: 单元格竖直方向格数
 * ```
 */
export const GridItem: FC<GridItemProps> = (props) => {
  const { xSpan = 1, ySpan = 1, ...otherProps } = props;
  const style: CSSProperties & TPlainObject<string> = {};
  if (xSpan > 1) {
    style['--grid-column'] = `span ${xSpan || 1}`;
  }
  if (ySpan > 1) {
    style['--grid-row'] = `span ${ySpan || 1}`;
  }

  return withNativeProps(
    props,
    <div {...otherProps} className={'v-grid-item'} style={style}>
      {props.children}
    </div>,
  );
};
